// DS6.1.2 (!) You might want to use MenuList.tsx
//             that accepts an array of items and renders:
//             ListCard.tsx + ListItem.tsx[] composition
import React, { HTMLAttributes } from 'react';
import c from 'classnames';
import {
  ThemeOverride,
  ThemeSurface,
} from '@wix/da-react-context/pkg/ThemeContext';
import s from './ListCard.scss';

export interface Props extends HTMLAttributes<HTMLDivElement> {
  innerRef?: React.RefCallback<HTMLDivElement>;
}

const ListCard: React.FC<Props> = ({
  className,
  children,
  innerRef,
  ...props
}) => {
  const content = (
    <div
      className={c('ds-surface-tertiary', s['content'], className)}
      ref={innerRef}
      {...props}
    >
      {children}
    </div>
  );

  return (
    <ThemeOverride themeSurface={ThemeSurface.TERTIARY} tag="div">
      {content}
    </ThemeOverride>
  );
};
ListCard.displayName = 'ListCard';

export default ListCard;
